import React from 'react';
import dayjs from 'dayjs';
import { ActionGrid, ActionButton, Container } from './styles';

interface ShiftActionsProps {
  onAssign: () => void;
  onBroadcast: () => void;
  // onSplit: () => void;
  onEdit: () => void;
  onCancel: () => void;
  onDelete?: () => void;
  onExtend: () => void;
  onApprove?: () => void;
  onClockIn?: () => void;
  onClockOut?: () => void;
  isClockedIn?: boolean;
  isClockedOut?: boolean;
  hideExtend?: boolean;
  hideEdit?: boolean;
  shiftStatus?: string;
  isFull?: boolean;
  endTime?: string;
}

const ShiftActions: React.FC<ShiftActionsProps> = ({
  onAssign,
  onBroadcast,
  // onSplit,
  onEdit,
  onCancel,
  onDelete,
  onExtend,
  onApprove,
  onClockIn,
  onClockOut,
  isClockedIn = false,
  isClockedOut = false,
  hideExtend = false,
  hideEdit = false,
  shiftStatus = '',
  isFull = false,
  endTime,
}) => {
  const isStarted = ['started', 'partially_started'].includes(shiftStatus.toLowerCase());
  const hideAssignBroadcast = isStarted || isFull;
  const hideEditCancel = isStarted;
  const isPastEndTime = endTime ? dayjs().isAfter(dayjs(endTime)) : false;
  const isCancelled = shiftStatus.toLowerCase() === 'cancelled';
  const isPendingApproval = [
    'facility_approval_pending',
    'approval_pending',
    'partially_approval_pending',
  ].includes(shiftStatus.toLowerCase());
  const isCompleted = shiftStatus.toLowerCase() === 'completed';

  if (isCompleted) {
    return (
      <Container>
        {!hideEdit && (
          <div style={{ marginTop: '12px' }}>
            <ActionButton variant="outlined" colorType="green" fullWidth onClick={onEdit}>
              Edit Shift
            </ActionButton>
          </div>
        )}
      </Container>
    );
  }

  if (isCancelled) {
    return (
      <Container>
        {onDelete && (
          <div style={{ marginTop: '12px' }}>
            <ActionButton variant="outlined" colorType="red" fullWidth onClick={onDelete}>
              Delete Shift
            </ActionButton>
          </div>
        )}
      </Container>
    );
  }

  if (isPendingApproval) {
    return (
      <Container>
        {onApprove && (
          <div style={{ marginTop: '12px' }}>
            <ActionButton variant="contained" colorType="green" fullWidth onClick={onApprove}>
              Approve Shift
            </ActionButton>
          </div>
        )}
        {!hideEdit && (
          <div style={{ marginTop: '12px' }}>
            <ActionButton variant="outlined" colorType="green" fullWidth onClick={onEdit}>
              Edit Shift
            </ActionButton>
          </div>
        )}
        {onCancel && (
          <div style={{ marginTop: '12px' }}>
            <ActionButton variant="outlined" colorType="red" fullWidth onClick={onCancel}>
              Cancel Shift
            </ActionButton>
          </div>
        )}
      </Container>
    );
  }

  const showClockIn = !isClockedIn && (shiftStatus.toLowerCase() === 'absent' || shiftStatus.toLowerCase() === 'start' || shiftStatus.toLowerCase() === 'started' || shiftStatus.toLowerCase() === 'partially_started') && onClockIn;
  const showClockOut = isClockedIn && !isClockedOut && (shiftStatus.toLowerCase() === 'start' || shiftStatus.toLowerCase() === 'started' || shiftStatus.toLowerCase() === 'partially_started') && onClockOut;

  return (
    <Container>
      {showClockIn && (
        <div style={{ marginTop: '12px' }}>
          <ActionButton variant="contained" colorType="green" fullWidth onClick={onClockIn}>
            Clock In
          </ActionButton>
        </div>
      )}
      {showClockOut && (
        <div style={{ marginTop: '12px' }}>
          <ActionButton variant="outlined" colorType="blue" fullWidth onClick={onClockOut}>
            Clock Out
          </ActionButton>
        </div>
      )}
      <ActionGrid>
        {!hideAssignBroadcast && (
          <ActionButton variant="contained" colorType="green" onClick={onAssign}>Manual Assign</ActionButton>
        )}
        {!hideAssignBroadcast && (
          <ActionButton colorType="blue" onClick={onBroadcast}>Re-broadcast</ActionButton>
        )}
        {!hideExtend && !isPastEndTime && (
          <ActionButton variant="outlined" colorType="blue" onClick={onExtend}>Extend Shift</ActionButton>
        )}
        {!hideEdit && (
          <ActionButton variant="outlined" colorType="green" onClick={onEdit}>Edit Shift</ActionButton>
        )}
      </ActionGrid>

      {!hideEditCancel && (
        <div style={{ marginTop: '12px' }}>
          <ActionButton variant="outlined" colorType="red" fullWidth onClick={onCancel}>
            Cancel Shift
          </ActionButton>
        </div>
      )}
    </Container>
  );
};

export default ShiftActions;
